import React, { useState, useEffect, useCallback } from 'react';
import RevealOnScroll from './RevealOnScroll';
import Papa from 'papaparse';
import "../components_style/Testimonials.css";

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [error, setError] = useState(null);
    
    const [loading, setLoading] = useState(true);

    const GOOGLE_SHEET_CSV_URL =
        'https://docs.google.com/spreadsheets/d/1zB36bX3rMBIKmxP78xIXXdIkGw3IuhWeZjeOXpr8AZw/export?format=csv&gid=0';

    const fetchTestimonials = useCallback(() => {
        setLoading(true);
        setError(null);
        fetch(GOOGLE_SHEET_CSV_URL)
            .then((response) => {
                if (!response.ok) throw new Error('Network error');
                return response.text();
            })
            .then((csvText) => {
                Papa.parse(csvText, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        setTestimonials(results.data || []);
                        setLoading(false);
                    },
                    error: (err) => {
                        setError('Failed to parse Google Sheet.');
                        setLoading(false);
                    },
                });
            })
            .catch(() => {
                setError('Could not fetch Google Sheet.');
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchTestimonials();
    }, [fetchTestimonials]);
    if (error) {
        return (
            <section className="testimonials-section">
                <div className="container error-container">
                    <RevealOnScroll>
                        <div className="error-card" role="alert" aria-live="polite">
                            <div className="error-media">
                                <svg className="error-svg" viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" fill="#ffe9e6" />
                                    <path d="M12 7v6" stroke="#d9534f" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="12" cy="17" r="1" fill="#d9534f" />
                                </svg>
                            </div>
                            <div className="error-content">
                                <h2>Testimonials Temporarily Unavailable</h2>
                                <p className="muted">We’re having trouble loading client reviews right now. Please try again in a moment.</p>
                                <div className="error-actions">
                                    <button className="btn primary" onClick={fetchTestimonials}>
                                        Retry
                                    </button>
                                    <button className="btn secondary" onClick={() => window.open('/contact', '_self')}>
                                        Contact Us
                                    </button>
                                </div>
                            </div>
                        </div>
                    </RevealOnScroll>
                </div>
            </section>
        );
    }

    if (loading) {
        return (
            <section className="testimonials-section">
                <div className="container">
                    <div className="loading-row">
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text">Loading testimonials…</div>
                    </div>
                </div>
            </section>
        );
    }

    if (testimonials.length === 0) {
        return (
            <section className="testimonials-section">
                <div className="container empty-container">
                    <RevealOnScroll>
                        <div className="empty-card">
                            <svg className="empty-icon" viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a2 2 0 11.001 3.999A2 2 0 0112 6zm1 12h-2v-2h2v2zm0-4h-2V8h2v6z" fill="#0b64d6"/>
                            </svg>
                            <div className="empty-text">
                                <h3>No Testimonials Yet</h3>
                                <p>We don’t have any client reviews to display right now. Check back soon or <a href="/contact">let us know</a> how we did.</p>
                            </div>
                        </div>
                    </RevealOnScroll>
                </div>
            </section>
        );
    }

    return (
        <section className="testimonials-section">
            <div className="container">
                <RevealOnScroll>
                    <h2>What Our Clients Say</h2>
                </RevealOnScroll>
                
                <div className="testimonial-grid">
                    {testimonials.map((item, index) => (
                        <RevealOnScroll key={index}>
                            <div className="testimonial-card">
                                <p>"{item.quote}"</p>
                                <cite>- {item.author}, {item.position}</cite>
                            </div>
                        </RevealOnScroll>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;